import FreelanceCompanyDetails from "../../views/WorkForceFreelanceCompanies/FreelanceCompanyDetails";

const WorkForceFreelanceCompanyDetailsPage = () => {
  return <FreelanceCompanyDetails />;
};

export default WorkForceFreelanceCompanyDetailsPage;
